import { Component, Input } from '@angular/core';
import { ButtonComponent, ButtonSize } from '../button/button.component';
import { IconComponent, IconName } from '../icon/icon.component';

@Component({
  selector: 'web-design-system-icon-button',
  imports: [ButtonComponent, IconComponent],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
})
export class IconButtonComponent {
  @Input() public icon: IconName;
  @Input() public type: IconButtonType = 'default-light';
  @Input() public size: ButtonSize = 'medium';
  @Input() public disabled = false;
  @Input() public fullwidth = false;
}

type IconButtonType = 'default-light' | 'red-light' | 'green-light' | 'grey-light' | 'old-buy' | 'old-sell' | 'old-savings-plan';
